import servicesUtils from "../../../utils/servicesUtils";
var getWorkspaceConfig = function getWorkspaceConfig(workspaceId) {
  return servicesUtils.getService("/workspaces/".concat(workspaceId, "/config"));
};
export default getWorkspaceConfig;